<template>
  <div class="box" id="tool-box" ref="boxRef">
    <li
      v-for="(item, index) in toolList"
      :key="item.nature"
      @click="selectType(item)"
      :class="{ active: item.nature === state.currentType.nature }"
    >
      <img :src="changeImg(item)" alt="" />
      <span>{{ item.name }}</span>
    </li>
    <p>
      <img
        src="../../../../assets/game/gmTool/tool_box_btn.png"
        @click="openBox"
      />
    </p>
  </div>
</template>
<script setup>
import { ref, reactive, onDeactivated, computed, defineProps } from "vue";

const state = reactive({
  currentType: {},
});

const toolList = ref([
  {
    name: "发放道具",
    icon: require("../../../../assets/game/gmTool/ic_send.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_send_active.png"),
    nature: "SENDTOOL",
  },
  {
    name: "停止发放",
    icon: require("../../../../assets/game/gmTool/ic_stop.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_stop_active.png"),
    nature: "STOPSEND",
  },
  {
    name: "选中10次",
    icon: require("../../../../assets/game/gmTool/ic_ten.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_ten_active.png"),
    nature: "SELECTTEN",
  },
  {
    name: "到结尾",
    icon: require("../../../../assets/game/gmTool/ic_toend.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_toend_active.png"),
    nature: "TOEND",
  },
  {
    name: "后20项",
    icon: require("../../../../assets/game/gmTool/ic_twenty.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_twenty_active.png"),
    nature: "LATERTWENTY",
  },
  {
    name: "查看日志",
    icon: require("../../../../assets/game/gmTool/ic_viewlog.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_viewlog_active.png"),
    nature: "VIEWLOG",
  },
  {
    name: "清空日志",
    icon: require("../../../../assets/game/gmTool/ic_clearlog.png"),
    icon_active: require("../../../../assets/game/gmTool/ic_clearlog_active.png"),
    nature: "CLEARLOG",
  },
]);

const changeImg = computed((data) => {
  return (data) => {
    if (data.nature === state.currentType.nature) {
      return data.icon_active;
    } else {
      return data.icon;
    }
  };
});

// 底部按钮状态更改
const boxRef = ref(null);
const openBox = () => {
  if (boxRef.value.classList.contains("active")) {
    boxRef.value.classList.remove("active");
  } else {
    boxRef.value.classList.add("active");
  }
};

// 当前选中的工具类型

const emit = defineEmits(["onAction"]);

const selectType = (type) => {
  //   console.log("当前选中的工具类型-------", type, state.currentType);
  state.currentType = type;
  emit("onAction", state.currentType);
};

onDeactivated(() => {
  boxRef.value.classList.remove("active");
});
</script>
<style scoped>
.box {
  width: 112px;
  height: 112px;
  background: #ffffff;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.05),
    -4px 0px 8px 0px rgba(0, 0, 0, 0.05), 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
  /* border-top-left-radius: 198px;
  border-top-right-radius: 198px; */
  border-radius: 198px;
  position: fixed;
  bottom: 202px;
  left: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  transition: all 0.5s ease;
  z-index: 9;
}
.box.active {
  height: 886px;
  padding: 36px 0 132px;
}
.box > p {
  background: linear-gradient(#ff6f38 0%, #f9d423 100%);
  box-shadow: 0px 8px 8px 0px rgba(255, 111, 56, 0.25);
  width: 112px;
  height: 112px;
  vertical-align: bottom;
  position: absolute;
  bottom: 0;
  transition: all 0.5s ease;
  border-radius: 198px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.box > p img {
  width: 64px;
  height: 64px;
  transition: all 0.5s ease;
}
.box.active > p img {
  transform: rotate(135deg);
}

.box li {
  font-size: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #cccccc;
}
.box li.active {
  color: #ff6f38;
}
.box li img {
  margin-top: 12px;
  width: 40px;
  height: 40px;
}
</style>
